import { render, staticRenderFns } from "./FormatText.vue?vue&type=template&id=076cab92&scoped=true&"
import script from "./FormatText.vue?vue&type=script&lang=js&"
export * from "./FormatText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076cab92",
  null
  
)

export default component.exports